import React from 'react';
import PlaceholderPage from './PlaceholderPage';

const InternationalStudents = () => {
  return (
    <PlaceholderPage title="International Students">
      Welcome international students! Find all the information you need about studying at FIC College, including visa requirements and support services.
    </PlaceholderPage>
  );
};

export default InternationalStudents;
